(function () {
    'use strict';

    angular
        .module('recommendationModule')
        .directive('grcRecommendation', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addRecommendation = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', '$state', '$stateParams', 'historyCtxtService', 'recomConstants',
            function ($scope, $controller, $state, $stateParams, historyCtxtService, recomConstants) {

                // set feature role if it is on object.
                if ($scope.boxModel && $scope.boxModel.RecomBusinessUnit && $scope.boxModel.RecomBusinessUnit.FeatureRole){
                    $scope.boxFeatureRole = $scope.boxModel.RecomBusinessUnit.FeatureRole;
                }

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/recommendation/grcRecommendation.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || recomConstants.featureRoles;
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'Recommendation';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.readOnly = !$scope.boxPermissions.Edit;

                // Can Create Recommendation
                $scope.canCreateRecommendation = function () {
                    if ($scope.readOnly) return false;
                    if (_.isUndefined($scope.boxContext) || !$scope.boxContext.Observation.ObservationID) return false;

                    return $scope.boxContext.Observation.HasObservation_Edit;
                };

                // Go To Create Recommendation
                $scope.goToCreateRecommendation = function ($event) {
                    $event.stopPropagation();

                    var toState = 'observation.edit.recommendationAdd';

                    if ($stateParams.ctxStateName) {
                        historyCtxtService.goToState(toState,
                           {},
                           $stateParams.ctxStateName,
                           $stateParams.ctxItem
                        );

                        return;
                    }

                    historyCtxtService.goToState(toState,
                        {},
                        $state.current.name,
                        $scope.boxContext.Observation
                    );
                };
            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();